import React, { useState, useEffect } from "react";
import { formatNumber } from "utils/currencyFormat";
import { getDate } from "utils/formatDate";
import TextInputTwoRow from "components/GenericComponent/TextInputTwoRow";
import DateTimePicker from "../../../components/GenericComponent/DateTimePicker";
import { convertDate } from "utils/formatDate";

export const ThongTinNguoiGopVon = ({
  dataNguonVon,
  onChangeDate,
  updateTextValue,
  onChangeNumber,
  errors,
}) => {
  return (
    <>
      <div className="card-collapse collapse show">
        <div className="card-content">
          <div className="card-body">
            <div className="row">
              <div className="col-md-12">
                <div className="row">
                  <div className="col-md-3">
                    <TextInputTwoRow
                      labelClass="col-md-4 label-control"
                      inputClass="form-control input-sm"
                      inputWrapClass="col-md-8"
                      wrapperClass="form-group row"
                      labelText="Họ tên"
                      placeholder="Nhập họ tên"
                      inputProps={{
                        name: "ten",
                        onChange: updateTextValue("ten"),
                        value: dataNguonVon.ten,
                      }}
                    ></TextInputTwoRow>
                    {errors.ten && (
                      <div className="form-group row">
                        <label
                          className="col-md-4 label-control"
                          for="userinput2"
                        ></label>
                        <div className="col-md-12">
                          <span
                            className="canh-bao-red"
                            style={{ marginBottom: "10px" }}
                          >
                            {errors.ten}
                          </span>
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="col-md-3">
                    <label
                      className="label-control color7-bold"
                      for="userinput2"
                    >
                      {" "}
                      Ngày sinh <span className="canh-bao-red">*</span>
                    </label>
                    <br />
                    <div>
                      <DateTimePicker
                        value={convertDate(dataNguonVon.ngaysinh)}
                        name="ngaysinh"
                        onChange={onChangeDate("ngaysinh")}
                        placeholder="Chọn ngày sinh"
                      ></DateTimePicker>
                    </div>
                  </div>

                  <div className="col-md-3">
                    <TextInputTwoRow
                      labelClass="col-md-4 label-control"
                      inputClass="form-control input-sm"
                      inputWrapClass="col-md-8"
                      wrapperClass="form-group row"
                      placeholder="Nhập địa chỉ"
                      labelText="Địa chỉ"
                      inputProps={{
                        name: "diachi",
                        onChange: updateTextValue("diachi"),
                        value: dataNguonVon.diachi,
                      }}
                    ></TextInputTwoRow>
                  </div>

                  <div className="col-md-3">
                    <TextInputTwoRow
                      labelClass="col-md-4 label-control"
                      inputClass="form-control input-sm"
                      inputWrapClass="col-md-8"
                      wrapperClass="form-group row"
                      labelText="Số điện thoại"
                      placeholder="Nhập số điện thoại"
                      inputProps={{
                        name: "dienthoai",
                        onChange: updateTextValue("dienthoai"),
                        value: dataNguonVon.dienthoai,
                      }}
                    ></TextInputTwoRow>
                  </div>

                  <div className="col-md-3">
                    <TextInputTwoRow
                      labelClass="col-md-4 label-control"
                      inputClass="form-control input-sm"
                      inputWrapClass="col-md-8"
                      wrapperClass="form-group row"
                      placeholder="Nhập số CCCD"
                      labelText="Số CCCD"
                      inputProps={{
                        name: "cmnd",
                        onChange: updateTextValue("cmnd"),
                        value: dataNguonVon.cmnd,
                      }}
                    ></TextInputTwoRow>
                  </div>
                  <div className="col-md-3">
                    <label
                      className="label-control color7-bold"
                      for="userinput2"
                    >
                      {" "}
                      Ngày cấp
                    </label>
                    <br />
                    <div>
                      <DateTimePicker
                        value={convertDate(dataNguonVon.ngaycap)}
                        name="ngaycap"
                        onChange={onChangeDate("ngaycap")}
                        placeholder="Nhập ngày cấp"
                      ></DateTimePicker>
                    </div>
                  </div>

                  <div className="col-md-3">
                    <TextInputTwoRow
                      labelClass="col-md-4 label-control"
                      inputClass="form-control input-sm"
                      inputWrapClass="col-md-8"
                      wrapperClass="form-group row"
                      labelText="Nơi cấp"
                      placeholder="Nhập nơi cấp"
                      inputProps={{
                        name: "noicap",
                        onChange: updateTextValue("noicap"),
                        value: dataNguonVon.noicap,
                      }}
                    ></TextInputTwoRow>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
